import { SET_VIDEO_CONTENT } from '../constants/card';

const initState = {
  video: {
    videoUrl: null,
    duration: 0,
  },
};

const card = (state = initState, action = {}) => {
  switch (action.type) {
    case SET_VIDEO_CONTENT:
      return {
        ...state,
        video: {
          ...state.video,
          [action.payload.videoId]: {
            ...state.video[action.payload.videoId],
            ...action.payload,
          },
        },
      };
    default:
      return state;
  }
};

export default card;
